import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import TerminalService from '../services/TerminalService';
import { useInterval } from '../util/hooks';

const FileNotFound = props => {
  const { message, pageName, redirect, terminal, className, icon, ...rest } = props;
  const [seconds, setSeconds] = useState(5);

  if (redirect) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useInterval(() => {
      // eslint-disable-line
      if (seconds <= 0) {
        window.location = redirect;
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);
  }

  const openTerminal = () => {
    TerminalService.open(pageName);
  };

  const classes = classNames('loading-wrapper', className);

  if (terminal && pageName) {
    return (
      <div className={classes} {...rest}>
        <div className="loading-child">
          <Button
            size="lg"
            variant="dark"
            target="dsi-launch"
            onClick={openTerminal}
          >
            <span className="zmdi-hc-stack zmdi-hc-lg">
              <i className="zmdi zmdi-open-in-new zmdi-hc-stack-2x" />
            </span>
            Launch Terminal
          </Button>
        </div>
      </div>
    );
  }

  if (redirect) {
    return (
      <div className={classes} {...rest}>
        <div className="loading-child">
          <div>{message}</div>
          Redirecting to legacy version in {seconds} seconds.
        </div>
      </div>
    );
  }

  return (
    <div className={classes} {...rest}>
      {icon && <div className="loading-icon"><i className={icon} /></div>}
      <div className="loading-child">{props.children ? props.children : message}</div>
    </div>
  );
};

FileNotFound.defaultProps = {
  message: 'Page Not Found :(',
  pageName: '',
  redirect: '',
  terminal: false,
  icon: '',
};

FileNotFound.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  message: PropTypes.string,
  pageName: PropTypes.string,
  redirect: PropTypes.string,
  terminal: PropTypes.bool,
};

export default FileNotFound;
